import styled, { css } from 'styled-components';
import { TabsProps } from '@cld/tabs';
import { Layout } from '../constants';
import { Indicator } from './Indicator';

export const WrapperVertical = css`
  align-items: stretch;
  display: inline-flex;
  flex-direction: column;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
`;

export const WrapperHorizontal = css`
  align-items: flex-start;
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
`;

type WrapperProps = Pick<TabsProps, 'layout'> & {
  isVertical: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  ${({ isVertical }) => (isVertical ? WrapperVertical : WrapperHorizontal)};
  display: ${({ layout, isVertical }) => (layout === Layout.INLINE || isVertical ? 'inline-flex' : 'flex')};
  ${({ layout }) => (layout === Layout.FIXED && 'justify-content: center;')};
  position: relative;
  max-width: 100%;
  
  ${Indicator} {
    ${({ isVertical, layout }) => (!isVertical && layout === Layout.FIXED && 'top: 0; bottom: initial;')}
  }
`;
